export const FETCH_LOAD_ALL_TEMPLATE_REQUEST = 'FETCH_LOAD_ALL_TEMPLATE_REQUEST'
export const FETCH_LOAD_ALL_TEMPLATE_SUCCESS = 'FETCH_LOAD_ALL_TEMPLATE_SUCCESS'
export const FETCH_LOAD_ALL_TEMPLATE_FALUIRE = 'FETCH_LOAD_ALL_TEMPLATE_FALUIRE'
